import { render, staticRenderFns } from "./CardUsagesChart.vue?vue&type=template&id=817e6ec4&"
import script from "./CardUsagesChart.vue?vue&type=script&lang=js&"
export * from "./CardUsagesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports